import { Adapter as m } from "../../../../adapter.js";
import { KioskConfigurationServiceModel as t } from "./kioskConfigurationService.model.js";
class h extends m {
  adapt(e) {
    var i, n, r, o, s, g;
    return new t({
      text: (e == null ? void 0 : e.text) ?? {},
      design: {
        images: {
          header: (n = (i = e == null ? void 0 : e.design) == null ? void 0 : i.images) == null ? void 0 : n.header,
          dineIn: ((o = (r = e == null ? void 0 : e.design) == null ? void 0 : r.images) == null ? void 0 : o.dine_in) ?? "https://static.cheerfy.com/integration/images/kiosk/dinein.png",
          takeAway: ((g = (s = e == null ? void 0 : e.design) == null ? void 0 : s.images) == null ? void 0 : g.take_away) ?? "https://static.cheerfy.com/integration/images/kiosk/takeaway.png"
        }
      }
    });
  }
  serialize(e) {
    throw new Error("Method not implemented.");
  }
}
export {
  h as KioskConfigurationServiceAdapter
};
//# sourceMappingURL=kioskConfigurationService.adapter.js.map
